import { graphql, useFragment } from 'react-relay';
import type { OperatingRoomManagementFragment$key } from './__generated__/OperatingRoomManagementFragment.graphql';
import { Box, Button, useDisclosure } from '@vitvio/design-system';
import { CreateOperatingRoomModal } from './CreateOperatingRoomModal';

const fragment = graphql`
  fragment OperatingRoomManagementFragment on LocationConnection {
    edges {
      node {
        id
        name
      }
    }
  }
`;

interface Props {
  operatingRoom: OperatingRoomManagementFragment$key | undefined;
  hospitalId: string;
  reloadFn: () => void;
}

export function OperatingRoomManagement({ operatingRoom, hospitalId, reloadFn }: Props) {
  const data = useFragment(fragment, operatingRoom);

  const { isOpen, onClose, onOpen } = useDisclosure();

  function handleOperatingRoomSubmit(shouldReload: boolean) {
    if (shouldReload) {
      reloadFn();
    }
    onClose();
  }

  if (!data) {
    return null;
  }

  const hasOperatingRooms = (data?.edges?.length || 0) > 0;

  return (
    <Box>
      <CreateOperatingRoomModal hospitalId={hospitalId} isOpen={isOpen} onClose={handleOperatingRoomSubmit} />
      {!hasOperatingRooms && <Box>No operating rooms, please create one </Box>}
      {hasOperatingRooms && <Box>Available operating rooms: </Box>}
      {data?.edges?.map((operatingRoom) => (
        <Box key={operatingRoom?.node?.id}>{operatingRoom?.node?.name}</Box>
      ))}

      <Box>
        <Button onClick={onOpen}>Create Operating Room</Button>
      </Box>
    </Box>
  );
}
